
import { useState } from "react";
import MessageSuccess from "../messages/messageSuccess";
import MessageError from "../messages/messageError";
import api from "../services/api";
import { useSelector } from "react-redux";
import ButtonLeft from "./buttonLeft";
import InputDocUpload from "./inputFileUpload/inputDocUpload";


export default function DocEdit({ anexo, nomeDoc, estabelecimentoId, id, label, url }) {
    const [doc, setDoc] = useState('')
    const [open, setOpen] = useState(false)
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const user = useSelector(state => state.account.user);
    // console.log(estabelecimentoId)

    async function HandleChangeFile(file, name) {
        setDoc(file);
    }

    const submitEdit = async () => {
        setOpen(true)
        setMessageSuccess('')
        setMessageError('')

        const formData = new FormData();
        if (anexo) {
            formData.append('anexo', doc);
        } else {
            formData.append('doc', doc);
        }
        formData.append('nomeDoc', nomeDoc);

        formData.append('estabelecimentoId', estabelecimentoId ?? '');

        formData.append('solicitacaoImportacaoId', id ?? '');

        formData.append('declaracaoDesalfandegamentoId', id ?? '');

        formData.append('siteInfoId', id ?? '');

        formData.append('userId', user?._id ?? '');
        //    for (let dado of formData.values()) { console.log(dado); }

        await api.put(url ?? '/estabelecimento/edit-doc', formData)
            .then(res => {
                setOpen(false)
                setMessageSuccess(' Salvo com sucesso.')

                // console.log(res)
                window.location.reload()
            }).catch(err => {
                setOpen(false)
                setMessageError(err.response.data.message)
                // console.log(err)
            })
    }

    return (
        <>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <InputDocUpload
                imputLigth={true}
                fullWidth={true}
                onFileSelect={HandleChangeFile}
                inputName={nomeDoc}
                inputDescription={label}
                inputTitle={label}
            />

            <ButtonLeft title={'Salvar'} funcao={() => submitEdit()} disabled={!doc} load={open} />
        </>
    )
}